import type { CollectionKind, LabelKind } from '@/api/types';

export const COLLECTION_KINDS: { value: CollectionKind; label: string; description: string }[] = [
  {
    value: 'editorial_row',
    label: 'Editorial row',
    description: 'A homepage row chosen by Playbox.',
  },
  { value: 'hero', label: 'Hero', description: 'The large feature at the top of the homepage.' },
  {
    value: 'browse',
    label: 'Browse',
    description: 'A themed list in browse, not on the homepage.',
  },
];

export const LABEL_KINDS: { value: LabelKind; label: string }[] = [
  { value: 'editorial', label: 'Playbox picks (editorial)' },
  { value: 'promoted', label: 'Promoted' },
];

export const kindLabel = (k: CollectionKind) =>
  COLLECTION_KINDS.find((x) => x.value === k)?.label ?? k;
